import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { formatCurrency } from 'utils/l10n';
import Asset from './Asset';
import ModalGallery from './ModalGallery';
import Tooltip from './Tooltip';

import './pricing-card.less';
import { CTA_TYPES, STANDARD_EVENTS } from 'utils/analytics/trackV2';

const PricingCard = ({ pricingCard, size, handleTrack }) => {
  const className = useClassName('ModularPricingCard');
  const headerExtraClasses = [];
  const [openModal, setOpenModal] = useState(false);
  if (!pricingCard.asset)
    headerExtraClasses.push(...['card-header-main', `card-header-${size}`]);

  const handleHeaderClick = () => {
    if (!pricingCard.asset && pricingCard.imageGallery) {
      handleTrack({
        event: STANDARD_EVENTS.click,
        cta_type: CTA_TYPES.modal,
      });
      setOpenModal(true);
    }
  };

  const handleImageClick = () => {
    if (pricingCard.imageGallery) {
      handleTrack({
        event: STANDARD_EVENTS.click,
        cta_type: CTA_TYPES.modal,
      });
      setOpenModal(true);
    }
  };

  const handleCloseModal = () => setOpenModal(false);

  const getPrice = () => {
    if (pricingCard.regularPrice && pricingCard.peakPrice) return null;
    if (pricingCard.regularPrice) return pricingCard.regularPrice;
    if (pricingCard.peakPrice) return pricingCard.peakPrice;
    return null;
  };

  const renderPrice = (price, type, toolTip) => (
    <div className={className('card-price')}>
      <div className={className('card-price-container')}>
        <p className={className('card-price-title')}>{type}</p>
        {toolTip && (
          <Tooltip iconName="question-circle" tooltipText={toolTip} />
        )}
      </div>
      <p className={className('card-price-value')}>
        {formatCurrency(price * 100)}
      </p>
    </div>
  );

  const renderModalGallery = () =>
    pricingCard.imageGallery && (
      <ModalGallery
        overlineText={pricingCard.description}
        title={pricingCard.title}
        price={getPrice()}
        body={pricingCard.body}
        imageGallery={pricingCard.imageGallery}
        open={openModal}
        handleClose={handleCloseModal}
      />
    );

  return (
    <div className={className(['card', `card-${size}`])}>
      {pricingCard.asset && (
        <div
          className={className(['card-image', `card-image-${size}`])}
          onClick={handleImageClick}>
          <Asset asset={pricingCard.asset} />
        </div>
      )}
      <div
        className={className(['card-header', ...headerExtraClasses])}
        onClick={handleHeaderClick}>
        <p className={className('card-title')}>{pricingCard.title}</p>
        <p className={className('card-description')}>
          {pricingCard.description}
        </p>
      </div>
      <div className={className('card-prices')}>
        {pricingCard.regularPrice &&
          renderPrice(pricingCard.regularPrice, 'Non-Peak Price')}
        {pricingCard.peakPrice &&
          renderPrice(
            pricingCard.peakPrice,
            'Peak Price',
            pricingCard.tooltipPeak
          )}
        {pricingCard.superPeakPrice &&
          renderPrice(
            pricingCard.superPeakPrice,
            'Super Peak Price',
            pricingCard.tooltipSuperPeak
          )}
      </div>
      {pricingCard.imageGallery && renderModalGallery()}
    </div>
  );
};

PricingCard.propTypes = {
  pricingCard: PropTypes.object.isRequired,
  size: PropTypes.string,
  handleTrack: PropTypes.func,
};

PricingCard.defaultProps = {
  size: 'big',
  handleTrack: () => {},
};

export default PricingCard;
